import type { BuildingDefinition, UnitDefinition } from "./types.js";

export const BUILDINGS = [
  building(
    "mining-rig",
    "Mining Rig",
    40,
    40,
    1,
    "industry",
    [{ quantity: "metal", perSecond: "2" }],
    10,
  ),
  building(
    "power-generator",
    "Power Generator",
    80,
    80,
    0,
    "supply",
    [{ quantity: "power", perSecond: "20" }],
    2,
  ),
  building(
    "construction-yard",
    "Construction Yard",
    600,
    600,
    2,
    "industry",
    [{ quantity: "construction-work", perSecond: "2" }],
    2,
  ),
  building(
    "rig-factory",
    "Rig Factory",
    200,
    200,
    4,
    "industry",
    [{ quantity: "mining-rig", perSecond: "0.025", consumesMetalPerSecond: "1" }],
    0,
  ),
  building(
    "yard-factory",
    "Yard Factory",
    900,
    900,
    4,
    "industry",
    [{ quantity: "construction-yard", perSecond: "0.01", consumesMetalPerSecond: "6" }],
    0,
  ),
  building(
    "factory-works",
    "Factory Works",
    3600,
    3600,
    12,
    "industry",
    [
      { quantity: "rig-factory", perSecond: "0.09", consumesMetalPerSecond: "18" },
      { quantity: "yard-factory", perSecond: "0.02", consumesMetalPerSecond: "18" },
      { quantity: "robot-factory", perSecond: "0.12", consumesMetalPerSecond: "18" },
    ],
    0,
  ),
  building(
    "robot-factory",
    "Robot Factory",
    150,
    150,
    4,
    "military-production",
    [{ quantity: "assembly-work", perSecond: "2" }],
    1,
  ),
  building(
    "research-lab",
    "Research Lab",
    100,
    100,
    3,
    "research",
    [{ quantity: "research-points", perSecond: "1" }],
    1,
  ),
  building(
    "shield-generator",
    "Shield Generator",
    100,
    100,
    4,
    "defenses",
    [{ quantity: "shield-charge", perSecond: "5", capacityPerUnit: "200" }],
    1,
  ),
  building(
    "supply-depot",
    "Supply Depot",
    120,
    120,
    2,
    "defenses",
    [{ quantity: "deployed-supply", perSecond: "0", capacityPerUnit: "40" }],
    0,
  ),
] as const satisfies readonly BuildingDefinition[];

export type BuildingId = (typeof BUILDINGS)[number]["id"];

export const UNITS = [
  unit("guard-robot", "Guard Robot", 12, 12, 80, 4, 1, 1, 10),
  unit("raider-robot", "Raider Robot", 10, 10, 40, 3, 3, 1, 0),
  unit("siege-gun", "Siege Gun", 30, 30, 80, 1, 16, 3, 0),
] as const satisfies readonly UnitDefinition[];

export type UnitId = (typeof UNITS)[number]["id"];

function building<const Id extends string>(
  id: Id,
  name: string,
  metalCost: number,
  workCost: number,
  power: number,
  department: BuildingDefinition["department"],
  outputs: readonly BuildingDefinition["outputs"][number][],
  initial: number,
): BuildingDefinition & { readonly id: Id } {
  return { id, name, metalCost, workCost, power, department, outputs, initial };
}

function unit<const Id extends string>(
  id: Id,
  name: string,
  metalCost: number,
  workCost: number,
  integrity: number,
  troopDamagePerSecond: number,
  infrastructureDamagePerSecond: number,
  supply: number,
  initialReserve: number,
): UnitDefinition & { readonly id: Id } {
  return {
    id,
    name,
    metalCost,
    workCost,
    integrity,
    troopDamagePerSecond,
    infrastructureDamagePerSecond,
    supply,
    initialReserve,
  };
}
